import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery
} from '@material-ui/core'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import ModalTitleIconed from 'asterX-UI/Modals/ModalTitleIconed'
import { AlertOctagonIcon } from 'asterX-UI/Icons'
import { AlertFutureIcon } from 'asterX-UI/Icons/AlertFutureIcon'
import InfoOctagonIcon from 'asterX-UI/Icons/InfoOctagonIcon'
import {
  ERROR_COLORS,
  INFO_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI/colors.constant'

const InfoModal = ({
  open,
  onClose,
  variant = '',
  title = '',
  btnText = 'OK',
  iconComponent = null,
  hasIcon = true,
  withoutButton = false,
  ...other
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'))

  const getIconComponent = () => {
    const [info, warning, error, success] = MODAL_STYLES.variant
    if (variant === info) {
      return <InfoOctagonIcon style={{ color: INFO_COLORS[600] }} />
    }
    if (variant === warning) {
      return <AlertOctagonIcon style={{ color: WARNING_COLORS[400] }} />
    }
    if (variant === error) {
      return (
        <AlertFutureIcon style={{ color: ERROR_COLORS[400], fontSize: 40 }} />
      )
    }
    if (variant === success) {
      return <AlertOctagonIcon style={{ color: SUCCESS_COLORS[600] }} />
    }
    return <AlertOctagonIcon />
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'xs' : 'sm'}
      fullWidth
      {...other}
    >
      <ModalTitleIconed
        onClose={onClose}
        variant={variant}
        hasIcon={hasIcon}
        iconComponent={iconComponent || getIconComponent()}
      >
        {title}
      </ModalTitleIconed>
      <DialogContent>{other.children}</DialogContent>
      {!withoutButton && (
        <DialogActions>
          <Button
            variant={'contained'}
            color={'primary'}
            fullWidth
            onClick={onClose}
          >
            {btnText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
export default InfoModal
InfoModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(MODAL_STYLES.variant),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}
